<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>STEP 5</div>
				<h2 waHeading="l" waText>Your First Component</h2>
				<p waBody="m" waColorText="quiet" waText>Java class in, Angular component out.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>Create your first page component. This code is identical for both modes &mdash; in Angular mode the build generates an Angular component; in hosted mode the same class is served by the Vert.x host. &#64;NgComponent gives it a selector. &#64;NgRoutable assigns its URL. The constructor builds the component tree in Java.</p>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>MyHomePage.java</div>
					<markdown [data]="mdContent_37" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>